import React from 'react';

const Navbar = () => (
  <div className="septa-calc-widget-header">
    <img src="./img/logo.svg" alt="Septa" className="septa-calc-widget-header-logo" />
    <h2>Regional Rail Fares</h2>
  </div>
);

export default Navbar;